module.exports = __webpack_public_path__ + "static/media/3-3.1940b631.svg";